import { render, staticRenderFns } from "./MarketingTutorial.vue?vue&type=template&id=097427bc&scoped=true&lang=pug"
import script from "./MarketingTutorial.vue?vue&type=script&lang=js"
export * from "./MarketingTutorial.vue?vue&type=script&lang=js"
import style0 from "./MarketingTutorial.vue?vue&type=style&index=0&id=097427bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097427bc",
  null
  
)

export default component.exports